"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmployeeDiscounts;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Helper_1 = require("../Helper");
const Theme_1 = require("../Theme");
const Screen_1 = __importDefault(require("../components/Screen"));
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const EmployeeDiscounts_1 = __importDefault(require("../api/EmployeeDiscounts"));
const Card_1 = __importDefault(require("../components/Card"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Button_1 = __importDefault(require("../components/Button"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
;
function DiscountCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const handleDiscountRedirect = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': `Employee Discount Redirect - ${Helper_1.Helper.FormatTitleCase(props.discount?.title)}`,
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        if (Helper_1.Helper.isPlatformWeb) {
            var url = props.discount?.url;
            if (!props.discount?.url.startsWith('http')) {
                url = 'https://' + props.discount?.url;
            }
            /* @ts-ignore */
            global.window.open(url, '_blank');
        }
        else {
            if (!props.discount?.url.startsWith('http'))
                props.navigation.navigate('WebScreen', { uri: 'https://' + props.discount?.url, title: props.discount?.title });
            else
                props.navigation.navigate('WebScreen', { uri: props.discount?.url, title: props.discount?.title });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { padding: 12 }, accessible: true, "aria-label": props.discount.title + ' logo', children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri: props.discount.gcpImageLink }, style: { height: 60, width: '100%', resizeMode: 'contain' } }) }), (0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: props.discount?.title ?? 'Other', "aria-label": props.discount?.title ?? 'Other', style: { marginBottom: 8, marginHorizontal: 12 } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { margin: 12, minHeight: 36 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'left', fontSize: size != 'sm' ? 14 : 12, color: THEME.Text }, children: props.discount.description }) }), (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('common:buttons.view'), type: "solid", onPress: handleDiscountRedirect, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { color: THEME.White, fontSize: size != 'sm' ? 16 : 14, fontWeight: '500' }, children: t('common:buttons.view') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, size: 18, color: THEME.White, style: { margin: 4, marginBottom: 2, marginLeft: 6 } })] })] }));
}
;
function EmployeeDiscounts(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const [status, setStatus] = react_1.default.useState(null);
    const [employeeDiscounts, setEmployeeDiscounts] = react_1.default.useState([]);
    const limitedView = userContext.isFormer || userContext.isContractor;
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh().then(() => setRefreshing(false));
        return () => promise.current?.cancel();
    }, []);
    const refresh = react_1.default.useCallback(async () => {
        if (limitedView)
            return;
        promise.current?.cancel();
        setStatus("loading");
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => EmployeeDiscounts_1.default.getList(token))).then((data) => {
            console.log("Employee Discounts: ", data);
            setEmployeeDiscounts(data);
            setStatus("done");
        }).catch((e) => {
            setEmployeeDiscounts([]);
            setStatus("error");
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { marginVertical: 6, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'contain', source: size != 'sm' ? Theme_1.IMAGES.InformationBackgroundWeb : Theme_1.IMAGES.InformationBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }) }), (0, jsx_runtime_1.jsx)(MasonryList_1.default, { data: employeeDiscounts, renderItem: ({ item }) => (0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(DiscountCard, { discount: item, navigation: props.navigation }) }), listEmpty: (0, jsx_runtime_1.jsx)(Card_1.default, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12 }, children: [status == "done"
                                    &&
                                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { margin: 24, flexDirection: "row", justifyContent: "center", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Tags, size: 28, color: THEME.Secondary, style: { marginRight: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextNull, fontSize: 18 }, children: t('eeDiscounts:text.noDiscounts') })] }), status == "loading"
                                    &&
                                        (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading", error: status == "error", onRetry: () => refresh() })] }) }) })] }) }));
}
